(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SubscriptionPackageDetailController', SubscriptionPackageDetailController);

    SubscriptionPackageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'SubscriptionPackage', 'PackageFeatureList'];

    function SubscriptionPackageDetailController($scope, $rootScope, $stateParams, entity, SubscriptionPackage, PackageFeatureList) {
        var vm = this;

        vm.subscriptionPackage = entity;

        var unsubscribe = $rootScope.$on('tikonApp:subscriptionPackageUpdate', function (event, result) {
            vm.subscriptionPackage = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
